import { Link } from "react-router-dom";

export default function Cancellation() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="mb-12 border-b border-neutral-200 pb-8">
        <div className="label-eyebrow mb-3">Legal</div>
        <h1 className="font-display font-medium text-4xl sm:text-5xl tracking-tight">Cancellation & Refund Policy</h1>
        <div className="mt-4 inline-block border border-amber-300 bg-amber-50 text-amber-900 text-xs px-3 py-1.5 rounded-sm">
          DRAFT · v1.0 · Referenced by Terms §7
        </div>
      </div>

      <div className="text-[15px] leading-relaxed space-y-8">
        <p className="italic text-neutral-600 border-l-2 border-neutral-300 pl-4">
          Referenced by <Link to="/terms" className="underline text-neutral-900">Terms of Service §7</Link>.
          Have this reviewed by counsel before it takes effect.
        </p>

        <Section title="1. Guest cancellations">
          <ul>
            <li><b>More than 24 hours before start:</b> full refund of the hourly fee.</li>
            <li><b>Within 24 hours of start:</b> 50% refund of the hourly fee.</li>
            <li><b>Within 1 hour of start, or no-show:</b> no refund. The Host may keep the full fee.</li>
          </ul>
        </Section>

        <Section title="2. Host cancellations">
          <p>If a Host cancels a confirmed booking:</p>
          <ul>
            <li>The Guest is refunded in full, automatically.</li>
            <li>The Host may be temporarily blocked from listing new bookings if cancellations become a pattern.</li>
            <li>Repeated last-minute Host cancellations may result in account suspension per Terms §8.</li>
          </ul>
        </Section>

        <Section title="3. Force majeure">
          <p>In the event of severe weather, public transit failure, government-ordered closure, or other
          circumstances outside either party's reasonable control, DenShare will refund the Guest in full
          and does not penalize the Host.</p>
        </Section>

        <Section title="4. Property damage or unsafe conditions">
          <p>If a Guest arrives at a workspace that is materially different from the listing (unsafe, unclean,
          missing advertised equipment, or inaccessible), they should contact DenShare within one hour and
          leave. DenShare will refund the full fee and investigate. Repeated verified reports may result in
          the listing being removed.</p>
          <p>If a Host discovers damage caused by a Guest, they may submit a report within 72 hours of the
          booking end. Disputes are between the Host and Guest per Terms §5; DenShare may assist in good
          faith but is not obligated to mediate or compensate.</p>
        </Section>

        <Section title="5. Payment mechanics">
          <p>Refunds are issued to the original payment method through our payment provider (Stripe).
          Depending on the card issuer, funds typically appear in 5–10 business days.</p>
        </Section>

        <div className="mt-14 pt-6 border-t border-neutral-200 flex items-center justify-between text-sm text-neutral-500">
          <span>Version 1.0 (draft)</span>
          <Link to="/terms" className="underline text-neutral-900">Terms of Service →</Link>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display font-medium text-xl tracking-tight mb-2">{title}</h2>
      <div className="space-y-2 text-neutral-700">{children}</div>
    </section>
  );
}
